// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"b5cc39e3","357":"a736b7bf","885":"cd8a6ea5","901":"a72f056e"}[chunkId] + ".chunk.js";
};